import { render, staticRenderFns } from "./EditSellerProfileTooltipContent.vue?vue&type=template&id=bb45460e&scoped=true&"
import script from "./EditSellerProfileTooltipContent.vue?vue&type=script&lang=js&"
export * from "./EditSellerProfileTooltipContent.vue?vue&type=script&lang=js&"
import style0 from "./EditSellerProfileTooltipContent.vue?vue&type=style&index=0&id=bb45460e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb45460e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VLayout})
